import * as requests from '../api-request'
import { withStream } from '../api-request'

const consumeFinalStreamPayload = async (response, cb) => {
  let finalPayload = null
  let finalError = null

  await withStream(response, 'json', (error, message) => {
    if (cb) {
      cb(error, message)
    }
    if (error) {
      finalError = error
      return
    }
    if (message?.streaming) return
    if (message?.error) {
      finalError = new Error(message.error.message || 'Request failed')
      return
    }
    finalPayload = message?.response || message
  })

  if (finalError) throw finalError
  return finalPayload
}

export const submitMessage = async (data = {}, signal, cb) => {
  return consumeFinalStreamPayload(
    await requests.headless('POST', 'agents/message', data, '', signal),
    cb
  )
}

export const submitScheduleSorting = async (data = {}, signal) => {
  return requests.toJSON('POST', 'agents/scheduling/sorting', data, '', signal)
}

export const submitScheduleSortingStreaming = async (data = {}, signal, cb) => {
  return withStream(
    await (requests.headless('POST', 'agents/scheduling/sorting', data, '', signal)),
    'blob',
    cb
  )
}

export const createPitchDeckTemplate = async (data = {}) => {
  return requests.toJSON('POST', 'agents/pitch_deck/create_template', data)
}

export const createChat = async (data = {}, token) => {
  return requests.toJSON('POST', 'agents/create_chat', data, token)
}

export const getHistory = async (data = {}) => {
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `agents/history/navigator_agent?${queryString}`, data)
}

export const getChat = async (data = {}, token) => {
  return requests.toJSON('POST', 'agents/get_chat', data, token)
}

export const deleteChat = async (chatId) => {
  return requests.toJSON('DELETE', `agents/chat/${chatId}`)
}
